import { SignUpRequest } from "src/entities/v3/SignUpRequest";
import { usePost } from "./usePost";

interface UseSignUpProps {
  onSuccess?: () => void;
  onError?: () => void;
}

export const useSignUp = ({ onSuccess, onError }: UseSignUpProps = {}) => {
  const { post, isLoading } = usePost<Record<string, never>>({
    method: "post",
    headers: {
      // Override Authorization header for signup endpoint
      authorization: "",
    },
    onSuccess,
    onError,
  });

  const signUp = async (request: SignUpRequest) => {
    const v3ApiUrl =
      process.env.REACT_APP_DOMAIN_V3 ||
      "https://vritimes-stg-singapore-publisher-server-v3-992468913627.asia-southeast1.run.app";

    await post({
      url: `${v3ApiUrl}/api/v3/auth/signup`,
      params: request,
    });
  };

  return {
    signUp,
    isLoading,
  };
};
